import { gql } from 'graphql-tag'

export const settingsFragment = gql`
  fragment SettingsFragment on Settings {
    id
    name
    category
    type
  }
`

export const fetchSettings = gql`
  query FetchSettings($stationId: ID!) {
    settings {
      ...SettingsFragment
    }
    stationSettings(stationId: $stationId) {
      ...SettingsFragment
    }
  }
  ${settingsFragment}
`

export const toggleStationSettings = gql`
  mutation ToggleStationSettings($stationId: ID!, $id: ID!) {
    toggleStationSettings(stationId: $stationId, id: $id) {
      ...SettingsFragment
    }
  }
  ${settingsFragment}
`
